export default __webpack_public_path__ + "static/media/bidifylogo_etc.b26440fe.png";